import { createSelector } from 'reselect';
import RfidFilesErrorsColumns from '../../containers/RfidFilesErrorsColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.RFID_FILES_ERRORS_LIST.isLoading;
export const getData = TableDefinitions.RFID_FILES_ERRORS_LIST.getDataFunction();
export const getColumns = createSelector(getData, RfidFilesErrorsColumns);
